var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.$route.name !== 'NotFound')?[_c('Header')]:_vm._e(),_c('div',{staticClass:"view"},[_c('router-view')],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }